// extracted by mini-css-extract-plugin
export var errorIcon = "_lw-1";
export var nameLogo = "_lw-0";